/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';

export interface GetSurveyQuestion$Plain$Params {

/**
 * id of surveyquestion for filter
 */
  surveyQuestionId: number;
}

export function getSurveyQuestion$Plain(http: HttpClient, rootUrl: string, params: GetSurveyQuestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyQuestion$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyQuestionId', params.surveyQuestionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyQuestionModel>;
    })
  );
}

getSurveyQuestion$Plain.PATH = '/api/SurveyQuestion/{surveyQuestionId}';
